import React, {ChangeEvent, KeyboardEvent, useCallback, useState} from "react";
import RainbowSDKService from "../services/RainbowSDKService";
import "./SendMessageBar.css";
import { useTranslation } from 'react-i18next';
import sendButton from '../img/sendButton.svg';


type SendMessageBarProps =  {
    bubble?: any;
    disabled?: boolean;
    handleMessageChange?: (event: ChangeEvent<HTMLInputElement>) => void;
    buttonAction?: (event: React.MouseEvent<HTMLButtonElement> | KeyboardEvent<HTMLInputElement>) => void;
}

const SendMessageBar: React.FC<SendMessageBarProps> = ({
                                                           bubble,
                                                           disabled = false,
                                                           handleMessageChange: propHandleMessageChange,
                                                           buttonAction: propButtonAction,
                                                       }) => {
    const [message, setMessage] = useState("");
    const [hasSendTyping, setHasSendTyping] = useState(false);
    const { t } = useTranslation();

    const handleMessageChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setMessage(value);

        if (propHandleMessageChange) {
            propHandleMessageChange(event);
            return;
        }

        // TODO : Add is typing method
        if (value.length > 0 && !hasSendTyping) {
            // RainbowSDKService.rainbowSDK.im.sendIsTypingStateInBubble(bubble, true);
            setHasSendTyping(true);
        } else if (value.length === 0) {
            // RainbowSDKService.rainbowSDK.im.sendIsTypingStateInBubble(bubble, false);
            setHasSendTyping(false);
        }
    }, [bubble, hasSendTyping, propHandleMessageChange]);

    const handleMessageSend = useCallback(() => {
        const trimmedMessage = message.trim();
        if (trimmedMessage.length > 0 && bubble) {
            RainbowSDKService.sendMessageToConversation(bubble, trimmedMessage);
            // RainbowSDKService.rainbowSDK.im.sendIsTypingStateInBubble(bubble, false);
            setMessage("");
            setHasSendTyping(false);
        }
    }, [bubble, message]);

    const handleKeyDown = useCallback((event: KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            if (propButtonAction) {
                propButtonAction(event);
            } else {
                handleMessageSend();
            }
        }
    }, [handleMessageSend, propButtonAction]);

    const buttonAction = propButtonAction || (() => handleMessageSend());

    return (
        <div id="send-message-bar" className="send-message-bar">
            <div className="send-message-bar-left"></div>
            <div className="send-message-bar-center">
                <input
                    id="message-to-send"
                    className="send-message-bar-text"
                    type="text"
                    placeholder={t("send_message_bar_input_placeholder") as string}
                    onChange={handleMessageChange}
                    onKeyDown={handleKeyDown}
                    disabled={disabled || !bubble}
                    value={message}
                />
            </div>
            <div className="send-message-bar-right">
                <button type="button" onClick={buttonAction} className="btn-send" disabled={disabled || !bubble || message.trim().length === 0}>
                    <img className="btn-img" src={sendButton} alt={t("alt_code_send_message_bar_send_button") as string} />
                </button>
            </div>
        </div>
    );
};

export default SendMessageBar;
